import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Button, Form } from "react-bootstrap";
import { useAlert } from "../../../../context/AlertContext";
import { useWebsiteName } from "../../../../context/WebsiteNameContext";
import { initializeSetOption } from "../../../../utils/InitializeSetDefault";
import { formatInputDate, toFormatISO } from "../../../../utils/Time";
import { formatDate } from "../../../../commons/FormatValue";
import {
  filteredCreateNewKey,
  filteredItemInRange,
} from "../../../../utils/ManageArray";
import {
  getServiceRequest,
  addEditServiceRequest
} from "../../../../commons/ServiceRequest";
import TableForm from "../../../../components/TableForm";
import ConfirmModal from "../../../../components/ConfirmModal";
import SearchFilter from "../../../../components/SearchFilter";
import CardDisplayComponent from "../../../../components/CardDisplayComponent";
import ReasonsService from "../../../../services/reasons.service";
import DepartJobsService from "../../../../services/departjob.service";
import TechniciansService from "../../../../services/technician.service";
import SequenceStatusService from "../../../../services/sequencestatus.service";
import TechnicianReceiveService from "../../../../services/technicianreceive.service";
import CustomersService from "../../../../services/customer.service";
import { useLoading } from "../../../../context/LoadingContext";
import InputSearch from "../../../../components/InputSearhComponent";
import { getQueryString } from "../../../../utils/Query";
import TableLimitPagination from "../../../../components/TableLimitPagination";
import PropTypes from "prop-types";
import TableForm2s from "../../../../components/TableFormScrb";
import moment from "moment";
export default function Teams({ defaultData }) {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { websiteName, setWebsiteName } = useWebsiteName();
  // const { loading, setLoading } = useLoading(false);
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const defaultDatas = [
    {
      Id: null,
      Seq_Inst_Id: 0, // Text type
      Job_Other_Id: 0,
      Seq_Pm_Id: 0,
      Seq_Serv_Id: null,
      Job_Type_Id: 0,
      Tech_Doc_No: null,
      Tech_Doc_Date: null,
      Seq_Status_Id: null,
      Depart_St_Id: null,
      Seq_St_Name: null,
      Com_Code: null,
      Tech_Mas_ID: null,
      Tech_Mas_Name: null,
      Job_Type_Name: null,
      Inform_Doc_No: null,
      Inform_Doc_Date: null,
      Job_Cus_Date: null,
      Ref_Doc_No: null,
      Ref_Doc_Date: null,
      Cus_Code: null,
      Cus_Name: null,
      Item_Code: null,
      Job_Actual_Date: null
    }
  ];
  const [allCountData, setAllCountData] = useState();
  const [data, setData] = useState([]);
  const [dataModal, setDataModal] = useState({ Array: [] });
  const [showModal, setShowModal] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [deapStsMas, setDeapStsMas] = useState([]);
  const [seqStsMas, setSeqStsMas] = useState([]);
  const [reasons, setReasons] = useState([]);
  const now = new Date();
  const vTechReject = [
    { Status: "Accept", Sts: false },
    { Status: "Reject", Sts: true }
  ];
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [CustomerCode, setCustomerCode] = useState([]);
  const [CustomerName, setCustomerName] = useState([]);
  const [JobType, setJobType] = useState([]);
  const [WorkNo, setWorkNo] = useState([]);

  const columns = [
    { name: "Job_Type_Name", label: "ประเภทงาน", readOnly: true, width: "190px" },
    { name: "Seq_No", label: "เลขที่ใบสั่งงาน", readOnly: true, width: "200px" },
    { name: "Cus_Code", label: "รหัสลูกค้า/สาขา", readOnly: true, width: "190px" },
    { name: "Cus_Name", label: "ชื่อลูกค้า/สาขา", readOnly: true, width: "250px", showTooltip: true },
    // {
    //   name: "Job_Cus_Date",
    //   label: "วันที่เข้างาน",
    //   readOnly: true,
    //   format: (row) => formatDate(row?.Job_Cus_Date),
    //   // width: "190px" 
    // },
    {
      name: "Tech_Rev_Date",
      label: "วันที่รับงาน",
      type: "date"
    },
    {
      name: "Seq_Status_Id",
      label: "สถานะใบสั่งงาน",
      type: "select",
      readOnly: true,
      // disabled: true,
      required: true,
      noneAsync: true,
      filterBy: ["Seq_St_Name"],
      options: initializeSetOption({
        key: "Id",
        label: "Seq_St_Name",
        dataset: seqStsMas
      }),
      width: "190px"
    },
    {
      name: "Depart_St_Id",
      label: "สถานะงาน",
      type: "select",
      required: true,
      noneAsync: true,
      filterBy: ["Depart_St_Name"],
      width: "200px",
      showTooltip: true,
      options: initializeSetOption({
        key: "Id",
        label: "Depart_St_Name",
        dataset: deapStsMas
      })
    },
    {
      name: "Reject_Reason",
      label: "เหตุผลที่ไม่รับงาน",
      type: "select",
      required: true,
      noneAsync: true,
      filterBy: ["Reason_Desc"],
      options: initializeSetOption({
        key: "Reason_Desc",
        label: "Reason_Desc",
        dataset: reasons
      }),
      width: "200px",
      // format: (row) => row.Tech_Reject ? false : true
    },
    // {
    //   name: "",
    //   readOnly: true,
    //   inputClass: "text-danger",
    //   width: "100px",
    //   format: (row) => row.Tech_Reject == "true" ? "Reject" : null
    // }
    {
      name: "Tech_Reject",
      label: "รับ/ไม่รับ",
      type: "select",
      required: true,
      noneAsync: true,
      filterBy: ["Status"],
      options: initializeSetOption({
        key: "Sts",
        label: "Status",
        dataset: vTechReject
      }),
      selectorColor: true
    },
  ];
  // const inputField = {
  //   filter: [
  const searchInput = [
    {
      name: "sup_team",
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: { label: "mb-3" },
      type: "text",
      disabled: true,
      size: 3,
      value: defaultData.team
    },
    {
      name: "start",
      label: "วันที่วางแผน",
      classNames: { label: "mb-3" },
      type: "date",
      max: "END",
      size: 3
    },
    {
      name: "job_type_id",
      label: "ประเภทงาน",
      classNames: { label: "mb-3" },
      size: 3,
      noneAsync: true,
      filterBy: ["Job_Type_Name"],
      options: initializeSetOption({
        key: "Id",
        label: "Job_Type_Name",
        dataset: JobType
      })
    },
    {
      name: "seq_no",
      label: "เลขที่ใบสั่งงาน",
      classNames: { label: "mb-3" },
      size: 3,
      filterBy: ["seq_no"],
      options: initializeSetOption({
        key: "seq_no",
        label: "seq_no",
        dataset: WorkNo
      }),
      queryService: (query, value) => {
        const q = getQueryString({
          seq_no: value, limit: 100, page: 1,
          plan_status: "OPEN"
        })
        getServiceRequest({
          showAlert,
          setLoading: () => { },
          serviceRequest: TechnicianReceiveService.getSeqNo(q),
          callback: (array) => {
            const newArray = array.map(arr => ({
              seq_no: arr.seqJob.seqNo
            }))
            setWorkNo(newArray)
          }
        });
      }
    },
    {
      name: "tech_mas_name",
      label: "ช่างผู้ปฏิบัติงาน",
      classNames: { label: "mb-3" },
      type: "text",
      disabled: true,
      size: 3,
      value: defaultData.tech_name
    },
    {
      name: "cus_code",
      label: "รหัสลูกค้า/สาขา",
      classNames: { col: "mb-3", label: "mb-1" },
      // required: true,
      // noneAsync: true,
      filterBy: ["Cus_Code"],
      options: initializeSetOption({
        label: "Cus_Code",
        key: "Cus_Code",
        // dataset: filteredItemInArray(
        //   data,
        //   "Cus_Code",
        //   data.Cus_Code
        // )
        dataset: CustomerCode
      }),
      queryService: (query) => {
        getServiceRequest({
          showAlert,
          setLoading: () => { },
          serviceRequest: CustomersService.getAllCustomers(query),
          callback: ({ items }) => setCustomerCode(items)
        });
      }
    },
    {
      name: "cus_name",
      label: "ชื่อลูกค้า/สาขา",
      classNames: { label: "mb-3" },
      size: 6,
      // required: true,
      // noneAsync: true,
      filterBy: ["Cus_Name"],
      options: initializeSetOption({
        key: "Cus_Name",
        label: "Cus_Name",
        dataset: CustomerName
      }),
      queryService: (query) => {
        getServiceRequest({
          showAlert,
          setLoading: () => { },
          serviceRequest: CustomersService.getAllCustomers(query),
          callback: ({ items }) => setCustomerName(items)
        });
      }
    },
  ]
  // }

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else if (dataModal.Array?.length) {
      setShowModal(true);
    }
  };

  const handleSearchFilter = (search) => {
    const allRowsEmpty = search.every((row) => {
      if (
        row.hasOwnProperty("value") &&
        row.value !== "" &&
        row.value !== null &&
        row.value !== undefined
      ) {
        return false;
      }
      return true;
    });
    if (allRowsEmpty) {
      GetAllTP();
      setTableData([]);
    } else {
      const [start, end] = search.filter(({ name, type }) =>
        ["START", "END"].some((suffix) => name.includes(suffix))
      );

      let filteredDate = filteredItemInRange(
        data,
        search,
        start?.name,
        end?.name
      );

      const newSearch = search.filter(item => item.name !== 'START' && item.name !== 'END');
      let filteredData = filteredCreateNewKey({
        data: filteredDate,
        search: newSearch,
        newName: ["Id"],
      });

      filteredData = data.filter((item) =>
        filteredData.some(({ name, value }) => item[name] === value)
      );

      const updatedData = filteredData.map(
        ({ ...item }) => ({ ...item })
      );
      // console.log('updatedData', updatedData)
      setTableData(search.some(({ value }) => value) ? updatedData : []);
    }
  };

  const handleSubmit = async (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);
    if (dataCallback) {
      try {
        const filteredArray = dataCallback;
        await handleSubmitPlanDts(filteredArray);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleSubmitPlanDts = async (Plan) => {
    await TechnicianReceiveService.createTechnicianReceive(Plan)
      .then(() => {
        showAlert({ error: "บันทึกสำเร็จ", type: "success" });
      })
      .catch(({ error, message }) => {
        showAlert({ error: message, type: "danger" });
      });
    setDataModal({ Array: [] })
    // setTableData([]);
    GetAllTP()
  };

  const pSetData = (vData) => {
    const newArray = vData?.map((items) => ({
      Id: items.id,
      Seq_Inst_Id: items?.Seq_Inst_Id,
      Job_Other_Id: items?.SeqOthersJob?.Job_Other_Id,
      Seq_Pm_Id: items?.Seq_Pm_Id,
      Seq_Serv_Id: items.Seq_Serv_Id,
      Job_Type_Id: items.SeqOthersJob?.InformOtherJob?.JobType?.Id ||
        items.RepairJobs?.job_type_id ||
        items.SeqInstalljob?.job_type_id,
      Seq_No: items.SeqOthersJob?.Seq_Oth_No ||
        items.SeqPmJob?.Seq_Pm_No ||
        items.RepairJobs?.seq_repair_no ||
        items.SeqInstalljob?.seq_install_no,
      Tech_Doc_No: items.Tech_Doc_No,
      Tech_Doc_Date: formatInputDate(items.Tech_Doc_Date, "Local").date,
      START: formatInputDate(items.Tech_Doc_Date, "Local").date,
      END: formatInputDate(items.Tech_Doc_Date, "Local").date,
      Seq_Status_Id: 2, //items.SequneceStatus?.Id,
      // Seq_St_Name: items.SequneceStatus?.Seq_St_Name,
      Depart_St_Id: items?.depart_st_id,
      Tech_Mas_ID: items.Technician?.Id,
      Tech_Mas_Name: items.Technician?.Tech_Mas_Name,
      Job_Type_Name: items.SeqOthersJob?.JobType?.Job_Type_Name ||
        // items.RepairJobs?.job_type_items?.Job_Type_Name ||
        items.RepairJobs?.JobType?.Job_Type_Name ||
        items.SeqInstalljob?.JobTypes?.Job_Type_Name,
      Cus_Code: items.SeqOthersJob?.InformOtherJob?.Customer?.Cus_Code ||
        items?.SeqInstalljob?.InformInstallJobs?.Customer?.Cus_Code ||
        items.RepairJobs?.informRepairJob?.concern_customer_items?.Cus_Code,
      Cus_Name: items.SeqOthersJob?.InformOtherJob?.Customer?.Cus_Name ||
        items.SeqInstalljob?.InformInstallJobs?.Customer?.Cus_Name ||
        items.RepairJobs?.informRepairJob?.concern_customer_items?.Cus_Name,
      Job_Actual_Date: formatInputDate(items.Job_Actual_Date, "Local").date,
      Reject_Reason: items.TechnicianReceive?.length ? items.TechnicianReceive[0]?.reject_reason : "",
      Tech_Rev_Date: formatInputDate(now, "Local").date,
      Tech_Reject: items.TechnicianReceive?.length ? items.TechnicianReceive[0]?.tech_reject : "",
      Com_Code: items.DepartJob?.Com_Code,
      Job_Cus_Date: formatInputDate(
        // items.SeqOthersJob?.InformOtherJob?.Job_Cus_Date,
        items.job_actual_date,
        "Local"
      ).date
    }));
    setData(newArray);
    setTableData(newArray || [])
  };

  const [querySearch, setQuerySearch] = useState()
  const GetAllTP = (search) => {
    setLoading(true)
    const page = search?.page || currentPage
    const limit = search?.limit || rowsPerPage
    const q = ({
      ...querySearch,
      page: page, limit: limit, ...search, plan_status: "OPEN",
      start: toFormatISO(search.start),
      end: toFormatISO(search?.start)
    })
    setQuerySearch(q)
    setCurrentPage(page)
    setRowsPerPage(limit)
    getServiceRequest({
      showAlert,
      setLoading: () => { },
      // serviceRequest: TechnicianPlansService.getAllTechnicianPlansStatus("OPEN"),
      // callback: (res) => { pSetData(res); setMainData(res) }
      serviceRequest: TechnicianReceiveService.getTechnicianReceiveFilter(getQueryString(q)),
      callback: (res) => {
        pSetData(res.data)
        setAllCountData(res.allCount)
        setLoading(false)
      }
    });
  };

  useEffect(() => {
    setWebsiteName("ทีมงานรับงาน");

    getServiceRequest({
      showAlert,
      setLoading: () => { },
      serviceRequest: ReasonsService.getAllReasons(),
      callback: (res) => setReasons(res)
    });

    setJobType(defaultData.job_type)

    getServiceRequest({
      showAlert,
      setLoading: () => { },
      serviceRequest: SequenceStatusService.getAllSequenceStatuses(),
      callback: (res) => setSeqStsMas(res)
    });
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: DepartJobsService.getAllDepartJobs(),
      callback: (res) => setDeapStsMas(res)
    });
  }, []);

  function setDefaultPage() {
    setTableData([])
    setCurrentPage(1)
    setQuerySearch({})
    setDataModal({ Array: [] })
  }

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Head Event Planning Page" />
      </Helmet>

      <Card className="m-1 mb-4 p-4 border-0">
        {/* <CardDisplayComponent
          body={{ element: InputSearch(inputField.filter, handleSearch) }}
        /> */}

        <Card.Body>
          <InputSearch
            data={data}
            // inputField={searchInput}
            showActionButtons={false}
            field={searchInput}
            searchCallback={search => search ? GetAllTP(search) : setDefaultPage()}
          />
        </Card.Body>
      </Card>

      <Form noValidate validated={validated} onSubmit={handleValidated}>
        <CardDisplayComponent
          header={{ title: { text: "รายละเอียดการวางแผน" } }}
          body={{
            element: (
              <TableForm2s
                data={tableData}
                defaultData={defaultDatas[0]}
                columns={columns}
                editForm={true}
                // activeButton={["delete"]}
                onChangeCallback={(newData, i) => {
                  const aForSave = newData.filter(d => d.isEdit)
                    .map((item) => ({
                      // id: null,
                      tech_plan_id: Number(item.Id),
                      seq_status_id: Number(item.Seq_Status_Id),
                      depart_st_id: Number(item.Depart_St_Id),
                      tech_mas_id: Number(item.Tech_Mas_ID),
                      job_type_id: Number(item.Job_Type_Id),
                      tech_rev_no: "", //techDocNo,
                      tech_rev_date: item.Tech_Rev_Date,
                      reject_reason: item.Reject_Reason,
                      tech_reject: item.Tech_Reject,
                      com_code: item.Com_Code
                    }));
                  setTableData(newData);
                  setDataModal({ Array: [...aForSave] });
                }}
                rowsPerPage={rowsPerPage}
                currentPage={currentPage}
                rowCount={allCountData}
                fetchData={GetAllTP}
                // sorting
                isLoading={loading}
              />
            )
          }}
          footer={{
            className: "text-end",
            element: (
              <>
                <Button
                  type="submit"
                  variant="success"
                  className="me-2 px-5 text-dark rounded-pill"
                  hidden={!tableData.length}
                >
                  บันทึกข้อมูล
                </Button>
                <ConfirmModal
                  show={showModal}
                  data={dataModal}
                  content={"add"}
                  onSubmitCallback={handleSubmit}
                />
              </>
            )
          }}
        />
      </Form>
    </>
  );
}
Teams.propTypes = {
  defaultData: PropTypes.object,
};